import { render, staticRenderFns } from "./right-area.vue?vue&type=template&id=6df73436&scoped=true&"
import script from "./right-area.vue?vue&type=script&lang=js&"
export * from "./right-area.vue?vue&type=script&lang=js&"
import style0 from "./right-area.vue?vue&type=style&index=0&id=6df73436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df73436",
  null
  
)

export default component.exports